import axios from 'axios';
import { IBinaryResponse } from '../interfaces/kattana';

export interface IBinaryApi {
  tradesEndpoint: string;
  trades: (
    network: string,
    pairAddress: string,
    authToken?: string,
    page?: number,
    before?: number,
    since?: number
  ) => Promise<IBinaryResponse>;
}

export class BinaryApi implements IBinaryApi {
  tradesEndpoint: string;

  constructor(apiGateway: string) {
    if (!apiGateway) {
      apiGateway = 'https://api.kattana.trade';
    }

    this.tradesEndpoint = `${apiGateway}/trades`;
  }

  /**
   * Fetch trades binary
   * Add buy boolean
   */
  public trades = async (
    network: string,
    pairAddress: string,
    authToken?: string,
    page?: number,
    before?: number,
    since?: number
  ): Promise<IBinaryResponse> => {
    try {
      const headers = authToken
        ? {
            Authorization: `Bearer ${authToken}`,
          }
        : undefined;
      const url = `${this.tradesEndpoint}/${network}/${pairAddress}/proto`;

      const params: any = {};

      if (page) {
        params.page = page;
      }
      if (before) {
        params.before = before;
      }
      if (since) {
        params.since = since;
      }

      const data = await axios.get(url, {
        params,
        responseType: 'arraybuffer',
        headers,
      });
      const uint8View = new Uint8Array(data.data);

      return {
        status: data.status,
        data: uint8View,
      };
    } catch (e) {
      console.warn(e);
      return {
        status: 400,
        data: new Uint8Array(),
        error: e,
      };
    }
  };
}
